export const LISTE_SURFACE = {
  title: 'Liste des surfaces',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste des surfaces',
  },
  actions: {
    add: 'Ajouter une surface',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    code: 'Code',
    ratio: 'Ratio',
  },
};

export const ADD_SURFACE = {
  titleAdd: 'Ajouter une surface',
  titleEdit: 'Modifier une surface',
  information: {
    libelle: 'Libellé',
    code: 'Code',
    ratio: 'Ratio',
  },
  success: {
    add: 'La surface a été ajouté avec succès.',
    edit: 'La surface a été modifié avec succès.',
  },
  error: {
    ratio: 'Ratio',
    code: 'Code',
    alreadySell: 'Impossible d\'augmenter le ratio d\'une surface dèja vendu',
  },
};
